import React from 'react';
import ContentPage from './ContentPage';

// Content now lives in the content_pages table (#66); see ContentPage.js.
function Contact() {
  return <ContentPage slug="contact" title="Contact" />;
}

export default Contact;
